/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export enum PeriodBackfillOrderOutcome {
    Minted = 'MINTED',
    Refused = 'REFUSED',
    Failed = 'FAILED'
}



